import mock from 'utils/mock';

mock.onGet('/api/dashboard').reply(200, {
  totalOverview: [
    { name: 'Total Balance', amount: '600,000.00' },
    { name: 'Total Fee', amount: '6,000.00' },
    { name: 'Total Charges', amount: '650,000.00' },
    { name: 'Total Transfers', amount: '50,000.00' },
    { name: 'Total Link Pay', amount: '50,000.00' }
  ],
  overview: [
    { name: 'Thai QR', amount: '249,900.00', fee: '249.00' },
    { name: 'QR Credit card', amount: '181,338.00', fee: '181.00' },
    { name: 'Alipay', amount: '285,666.00', fee: '285.00' },
    { name: 'Wechat', amount: '285,666.00', fee: '285.00' }
  ],
  chargeAndLinkpay: {
    label: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dataSet: [
      {
        name: 'Thai QR',
        data: [
          24916.5,
          24064,
          29742,
          29851,
          32490,
          30282,
          38121,
          40434,
          32490,
          30282,
          38121,
          40434
        ]
      },
      {
        name: 'QR Credit card',
        data: [
          11744,
          17722,
          16005,
          19771,
          20185,
          24377,
          32147,
          39387,
          20185,
          24377,
          32147,
          39387
        ]
      },
      {
        name: 'Alipay',
        data: [
          39387,
          119931,
          7988,
          12169,
          15112,
          22452,
          34400,
          34227,
          15112,
          22452,
          34400,
          34227
        ]
      },
      {
        name: 'Wechat',
        data: [
          39387,
          119931,
          7988,
          12169,
          15112,
          22452,
          34400,
          34227,
          15112,
          22452,
          34400,
          34227
        ]
      }
    ]
  },
  transfer: {
    label: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dataSet: [
      {
        name: 'K-Bank',
        data: [
          24916,
          24064,
          29742,
          29851,
          32490,
          30282,
          38121,
          40434,
          32490,
          30282,
          38121,
          40434
        ]
      },
      {
        name: 'SCB',
        data: [
          11744,
          17722,
          16005,
          19771,
          20185,
          24377,
          32147,
          39387,
          20185,
          24377,
          32147,
          39387
        ]
      },
      {
        name: 'BBL',
        data: [
          39387,
          119931,
          7988,
          12169,
          15112,
          22452,
          34400,
          34227,
          15112,
          22452,
          34400,
          34227
        ]
      },
      {
        name: 'KTB',
        data: [
          39387,
          119931,
          7988,
          12169,
          15112,
          22452,
          34400,
          34227,
          15112,
          22452,
          34400,
          34227
        ]
      }
    ]
  },
  earnings: [
    { label: 'Thai QR', value: 25 },
    { label: 'QR Credit card', value: 25 },
    { label: 'Alipay', value: 25 },
    { label: 'Wechat', value: 25 }
  ]
});
